import SaturnResponse from '@core/classes/Responses/SaturnResponse';
import { SaturnAssociation } from '@core/classes/SaturnAssociation';
import { SaturnMessage } from '@core/classes/SaturnMessage';
import request from '@core/services/request';
import { AxiosPromise } from 'axios';

export function getSaturnMessages(associations: SaturnAssociation[]) {
	return request.post(`/Messages/GetByAssociations`, associations);
}

export function markAsRead(messageId: string) {
	return request.post(`/Messages/MarkAsRead`, { messageId });
}

export function archive(messageId: string): AxiosPromise<SaturnResponse<SaturnMessage[]>> {
	return request.put(`/Messages/Archive`, { messageId });
}

export function MarkManyAsRead(messagesIds: string[], archive = false) {
	return request.put(`/Messages/MarkManyAsRead?archive=${archive}`, messagesIds);
}
